<template>
    <div>
        <template v-if="isLoading">
            <div class="row">
                <div class="col-md-12 d-flex">
                    <div class="skeleton-progress progress mr-2" style="width: 25%; height: 4em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                    <div class="skeleton-progress progress mr-2" style="width: 25%; height: 4em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                    <div class="skeleton-progress progress mr-2" style="width: 25%; height: 4em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                    <div class="skeleton-progress progress" style="width: 25%; height: 4em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="skeleton-progress progress" style="height: 30em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <tabs class="ses-tabs" :fill="0" :pills="0" :activeTab="0">
                <card shadow>
                    <template v-for="(training_video, key) in training_videos">
                        <tab-pane :key="key" :title="training_video.title" :id="key">
                            <h3 class="tab-title">{{ training_video.title }}</h3>
                            <div class="video_wrap">
                                <div v-for="(video, key) in training_video.videos" :key="key" class="video" @click="openVideo(video)">
                                    <img :src="video.thumbnail" class="thumbnail">
                                    <div class="title">
                                        <h3>{{ video.title }}</h3>
                                    </div>
                                </div>
                            </div>
                        </tab-pane>
                    </template>
                </card>
            </tabs>
        </template>
        <modal :show="showModal" v-on:close="showModal = false; video_obj = Object;">
            <template slot="header"><h3>{{ video_obj.title }}</h3></template>
            <template>
                <iframe width="100%" height="534" :src="video_obj.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </template>
        </modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isLoading: false,
            showModal: false,
            video_obj: Object,
            training_videos: []
        }
    },
    mounted() {
      if (localStorage.getItem('user') && localStorage.getItem('need_reset') !== '1') {
        this.get_training_videos()
      } else if (!localStorage.getItem('user')) {
        this.get_training_videos()
      }
    },
    methods: {
        get_training_videos() {
            this.isLoading = true
            this.$http.get('/api/training_videos')
                .then(response => {
                    this.training_videos = response.data.data
                    this.isLoading = false
                }).catch(() => {
                  this.isLoading = false
                });
        },
        openVideo(video) {
            this.showModal = true
            this.video_obj = video
        }
    }
}
</script>
<style lang="scss" scoped>
.tab-title {
    text-transform: uppercase;
    color: #000;
    font-size: 14px;
    font-weight: bold;
}
.modal::v-deep {
    .modal-dialog {
        max-width: 920px;
    }
    .modal-content {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .modal-body {
        padding: 0;
    }
}
.video_wrap {
    display: flex;
    flex-flow: row wrap;
    flex-direction: row;
    justify-content: center;
    .video {
        margin: 10px 9px;
        border-radius: 4px;
        overflow: hidden;
        display: inline-block;
        background: #dad9d9;
        max-width: 180px;
        .thumbnail {
            width: 100%;
            height: 103px;
            display: block;
            border-radius: 0;
        }
        .title {
            padding: 10px;
            h3 {
                line-height: 14px;
                font-weight: bold;
                color: #000000;
                vertical-align: middle;
                text-align: center;
                padding: 0;
                text-transform: uppercase;
                margin: 0;
                font-size: 11px;
            }
        }
    }
}
</style>
